import { __enforceTypescriptConstraint, removeReadonlyDeep } from '@feedyou/utils'
import { NonCollectionUniqueIdSchema } from '../utils/duplicateIdsSearchEngine'

export const BOT_UNIQUE_IDS_SCHEMA = removeReadonlyDeep({
  hasNoId: true,
  nestedEntities: [
    {
      key: 'dialogs',
      isCollection: true,
      collectionElementsShape: {
        nestedEntities: [
          {
            key: 'steps',
            isCollection: true,
            collectionElementsShape: {
              nestedEntities: [
                { key: 'answers', isCollection: true },
                { key: 'cases', isCollection: true },
                {
                  key: 'carousel',
                  isCollection: true,
                  collectionElementsShape: {
                    nestedEntities: [{ key: 'buttons', isCollection: true }]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      key: 'nlp',
      nestedEntities: [
        {
          key: 'models',
          isCollection: true,
          collectionElementsShape: {
            nestedEntities: [
              // Note:
              // entities[number].id and entities[number].options[number].id
              // are not included, because they refer to ids of existing entities
              { key: 'intents', isCollection: true }
            ]
          }
        }
      ],
      hasNoId: true
    }
  ]
} as const)

const DIALOG_UNIQUE_IDS_SCHEMA = BOT_UNIQUE_IDS_SCHEMA.nestedEntities[0].collectionElementsShape

export const STEP_UNIQUE_IDS_SCHEMA =
  DIALOG_UNIQUE_IDS_SCHEMA.nestedEntities[0].collectionElementsShape

export const NLP_SETTINGS_UNIQUE_IDS_SCHEMA = BOT_UNIQUE_IDS_SCHEMA.nestedEntities[1]

__enforceTypescriptConstraint<NonCollectionUniqueIdSchema>(BOT_UNIQUE_IDS_SCHEMA)
__enforceTypescriptConstraint<NonCollectionUniqueIdSchema>(DIALOG_UNIQUE_IDS_SCHEMA)
__enforceTypescriptConstraint<NonCollectionUniqueIdSchema>(STEP_UNIQUE_IDS_SCHEMA)
__enforceTypescriptConstraint<NonCollectionUniqueIdSchema>(NLP_SETTINGS_UNIQUE_IDS_SCHEMA)
